import {MiniFileData} from '../quickTrial';
import {TransformationObject} from '../QuickTrialScreen';
import React, {useEffect, useState} from 'react';
import {QuickTrialSideMenuItems} from '../SubMenuList';
import {Outlet} from 'react-router-dom';
import {ChevronDownWhite} from '../../../ui-components/Iconpack';

export interface SubMenuProps {
    fileData?: MiniFileData;
    transformationObject: TransformationObject;
    updateTransformationObject: (updatedProps: TransformationObject) => void;
    orgUid: string;
    trackEvent: (id: string, props: Object) => void;
    trackError: (e: any, id: string, props: Object) => void;
    ar?: number;
}

export const QuickTrialSideMenu: React.FC<SubMenuProps> = (props) => {
    const [activeItem, setActiveItem] = useState(0);
    const [showSubMenu, setShowSubMenu] = useState(false);

    useEffect(() => {
        props.fileData ? setShowSubMenu(true) : setShowSubMenu(false);
    }, [props.fileData]);

    return (
        <>
            <div
                className='fixed bottom-0 w-full overflow-auto bg-[#3E4784] md:relative md:h-full md:w-auto'
                style={{scrollbarWidth: 'none'}}>
                <ul className='flex items-center justify-start pt-3 md:flex-col md:justify-center md:gap-4 md:pt-4'>
                    {QuickTrialSideMenuItems.map((item, index) => {
                        return (
                            <li className='flex flex-col items-center justify-center' key={item.title}>
                                <div
                                    className={`cursor-pointer items-center justify-center rounded-[6px] p-[12px] md:mx-[16px] ${activeItem === index ? 'border-[2px] border-[#4E5BA6] bg-[#717BBC]' : 'bg-[#363F72]'}`}
                                    onClick={() => {
                                        setActiveItem(index);
                                        setShowSubMenu(true);
                                    }}>
                                    <item.icon color={activeItem === index ? '#FFFFFF' : '#B3B8DB'} />
                                </div>
                                <span
                                    className={`mx-[16px] pt-2 text-[12px] text-[#FFFFFF] ${activeItem === index ? 'font-[700]' : 'font-[400]'}`}>
                                    {item.title}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
            {showSubMenu && (
                <div className='fixed bottom-[90px] z-10 h-[280px] w-full overflow-y-auto bg-[#293056] px-4 pb-4 pt-[31px] md:relative md:bottom-0 md:h-full md:w-[240px]'>
                    <div className='flex justify-between'>
                        <div className='w-full'>
                            <Outlet />
                            {QuickTrialSideMenuItems[activeItem].componentView({...props})}
                        </div>
                        <div className='block md:hidden' onClick={() => setShowSubMenu(false)}>
                            <ChevronDownWhite width={24} height={24} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
